import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';
import Immutable from 'immutable';
import { SecondaryLink, ChevronLink } from '@bibliocommons/base-links';
import { catalogBibShape } from '@bibliocommons/bc-prop-types';
import Heading from '@bibliocommons/heading';
import Review from 'app/components/bibs/shared/Review';
import './CriticsReviews.scss';

const renderReviews = reviews => reviews.map(review => <Review review={review} compact key={review.get('id')} />);

export default function CriticsReviews({ reviews = Immutable.List(), totalReviews, catalogBib }) {
  if (reviews.size === 0) return null;

  // If there is a review from iDreamBooks, it will always come first in the backend response
  const firstReview = reviews.get(0);
  const linkToMoreReviews = firstReview.get('fullDetailsURI');

  return (
    <section className="cp-critics-reviews">
      <Heading tagName="h3" size="medium" variant>
        <FormattedMessage id="critics_reviews_section" />
      </Heading>
      <div className="reviews">{renderReviews(reviews)}</div>
      {totalReviews > reviews.size && (
        <ChevronLink
          className="all-reviews"
          dataKey="all-reviews"
          href={`/v2/record/${catalogBib.get('metadataId')}/reviews`}
        >
          <FormattedMessage id="view_all_reviews" values={{ count: totalReviews }} />
        </ChevronLink>
      )}
      {!!linkToMoreReviews && (
        <div className="more-reviews">
          <FormattedMessage
            id="read_more_reviews"
            values={{
              title: catalogBib.getIn(['brief', 'title']),
              link: (
                <SecondaryLink href={linkToMoreReviews} dataKey="more-reviews">
                  iDreamBooks.com
                </SecondaryLink>
              )
            }}
          />
        </div>
      )}
    </section>
  );
}

CriticsReviews.propTypes = {
  reviews: ImmutablePropTypes.list,
  totalReviews: PropTypes.number,
  catalogBib: catalogBibShape
};
